var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoConvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 73,
    viewBox: "0 0 188 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28062 19.6406C3.81022 19.6406 1.73828 21.4337 1.73828 23.5853V65.7015C1.73828 67.8531 3.77038 69.6462 6.28062 69.6462H34.9691C35.3277 69.6462 35.6863 69.5266 35.9652 69.3274L46.5241 61.4381C46.8429 61.199 47.0421 60.8404 47.0421 60.4419V23.5853C47.0421 21.4337 45.01 19.6406 42.4998 19.6406H6.28062V19.6406ZM6.28062 22.2704H42.5396C43.4162 22.2704 44.0537 22.8282 44.0537 23.5853V57.8122H38.0371C35.5667 57.8122 33.4948 59.6052 33.4948 61.7568V67.0164H6.28062C5.40403 67.0164 4.76651 66.4585 4.76651 65.7015V23.5853C4.80635 22.8282 5.44387 22.2704 6.28062 22.2704ZM38.0371 60.4419H43.2568L36.523 65.4624V61.7568C36.523 60.9998 37.1605 60.4419 38.0371 60.4419Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3705 11.7109C12.9001 11.7109 10.8281 13.504 10.8281 15.6556V16.4525C10.8281 17.1697 11.5055 17.7674 12.3422 17.7674C13.179 17.7674 13.8563 17.1697 13.8563 16.4525V15.6556C13.8563 14.8985 14.4939 14.3407 15.3705 14.3407H51.6295C52.506 14.3407 53.1436 14.8985 53.1436 15.6556V57.7718C53.1436 58.8875 52.267 59.0867 51.0716 59.0867C50.2349 59.0867 49.5575 59.6844 49.5575 60.4016C49.5575 61.1188 50.2349 61.7165 51.0716 61.7165C54.4585 61.7165 56.1718 60.1625 56.1718 57.7718V15.6954C56.1718 13.5438 54.1397 11.7508 51.6295 11.7508H15.3705V11.7109Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5705 4.34375C22.1798 4.34375 20.1875 6.05709 20.1875 8.16887V8.96578C20.1875 9.68299 20.825 10.2408 21.6618 10.2408C22.4587 10.2408 23.136 9.68299 23.136 8.96578V8.20872C23.136 7.49151 23.7736 6.93368 24.6103 6.93368H59.7536C60.5904 6.93368 61.2279 7.49151 61.2279 8.20872V49.0499C61.2279 50.1656 60.3912 50.3249 59.1958 50.3249C58.3989 50.3249 57.7215 50.8828 57.7215 51.6C57.7215 52.3172 58.3591 52.875 59.1958 52.875C62.4631 52.875 64.1366 51.4007 64.1366 49.0499V8.20872C64.1366 6.09693 62.1443 4.3836 59.7536 4.3836H24.5705V4.34375Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8188 28.8477C9.98205 28.8477 9.30469 29.4453 9.30469 30.1625C9.30469 30.8798 9.98205 31.4774 10.8188 31.4774H37.9931C38.8299 31.4774 39.5072 30.8798 39.5072 30.1625C39.5072 29.4453 38.8299 28.8477 37.9931 28.8477H10.8188Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8188 36.7383C9.98205 36.7383 9.30469 37.336 9.30469 38.0532C9.30469 38.7704 9.98205 39.3681 10.8188 39.3681H37.9931C38.8299 39.3681 39.5072 38.7704 39.5072 38.0532C39.5072 37.336 38.8299 36.7383 37.9931 36.7383H10.8188Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8188 44.625C9.98205 44.625 9.30469 45.2227 9.30469 45.9399C9.30469 46.6571 9.98205 47.2548 10.8188 47.2548H37.9931C38.8299 47.2548 39.5072 46.6571 39.5072 45.9399C39.5072 45.2227 38.8299 44.625 37.9931 44.625H10.8188Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8188 52.5547C9.98205 52.5547 9.30469 53.1524 9.30469 53.8696C9.30469 54.5868 9.98205 55.1845 10.8188 55.1845H29.5061C30.3429 55.1845 31.0202 54.5868 31.0202 53.8696C31.0202 53.1524 30.3429 52.5547 29.5061 52.5547H10.8188Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 2.60587,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 17.8086C137.009 17.8086 136.133 18.6055 136.133 19.6016C136.133 20.5977 137.049 21.3946 138.125 21.3946H174.185C175.3 21.3946 176.177 20.5977 176.177 19.6016C176.177 18.6055 175.261 17.8086 174.185 17.8086H138.125Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 4.24043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 28.6484C137.009 28.6484 136.133 29.4453 136.133 30.4415C136.133 31.4376 137.049 32.2345 138.125 32.2345H174.185C175.3 32.2345 176.177 31.4376 176.177 30.4415C176.177 29.4453 175.261 28.6484 174.185 28.6484H138.125Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 4.24043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 39.4883C137.009 39.4883 136.133 40.2852 136.133 41.2813C136.133 42.2774 137.049 43.0743 138.125 43.0743H174.185C175.3 43.0743 176.177 42.2774 176.177 41.2813C176.177 40.2852 175.261 39.4883 174.185 39.4883H138.125Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 4.24043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.125 50.3203C137.009 50.3203 136.133 51.1172 136.133 52.1133C136.133 53.1095 137.049 53.9064 138.125 53.9064H162.949C164.064 53.9064 164.941 53.1095 164.941 52.1133C164.941 51.1172 164.024 50.3203 162.949 50.3203H138.125V50.3203Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 4.24043,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.845 4.34375H175.737C180.399 4.34375 184.145 7.73058 184.145 11.9143V62.0394C184.145 66.2231 180.359 69.6099 175.737 69.6099H137.845C133.183 69.6099 129.438 66.2231 129.438 62.0394V21.7162",
    stroke: "#F78670",
    strokeWidth: 6.73218,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9414 41.1211C84.4566 52.4371 102.945 52.2379 114.261 40.7227",
    stroke: "#F78670",
    strokeWidth: 5.33051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.207 36.2188L117.527 38.1712L114.339 48.9692",
    stroke: "#F78670",
    strokeWidth: 5.33051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoConvert);
export default __webpack_public_path__ + "static/media/autoConvert.c92999542eaebfbbee5716b0033f632d.svg";
export { ForwardRef as ReactComponent };